import {Checkbox, Col, DatePicker, Form, Row, Select} from "antd";
import {useTranslation} from "react-i18next";
import {useForm} from "antd/es/form/Form";
import React, {useState} from "react";
import moment from "moment";
import {ExportBlob} from "../../../core/commons/export-blob/export.blob";
import {ExportFormat} from "../../../documents/documents.store";
import {articlesService} from "../../../../services/articles/articles.service";
import {downloadBlobFile} from "../../../../utils/download.blob";

export interface ResultExportModalProps {
    file: File;
    onClose: () => void;
}

export const ResultExportModal: React.FC<ResultExportModalProps> = ({file, onClose}) => {

    const { t } = useTranslation("translation", { useSuspense: false });

    const [submitting, setSubmitting] = useState<boolean>(false);
    const [form] = useForm();

    return (
        <ExportBlob<{ values: any }>
            title="DOWNLOAD.DO_DOWNLOAD"
            okText="DOWNLOAD.DO_DOWNLOAD"
            submitting={submitting}
            setSubmitting={setSubmitting}
            form={form}
            onSubmit={async (values) => {
                setSubmitting(true);
                try {
                    const {blob, filename} = await articlesService.downloadOEMByList(file, values)
                    downloadBlobFile(blob, filename);
                } finally {
                    setSubmitting(false)
                }
            }}
            onClose={() => onClose()}
            onInit={() => {
                return Promise.resolve({
                    format: 'csv',
                    withHeaders: true
                })
            }}
        >
            <Row gutter={[5, 5]}>
                <Col span={24}>
                    <Form.Item name={["withHeaders"]} valuePropName={"checked"}>
                        <Checkbox disabled={submitting}>{t("DOWNLOAD.WITH_HEADERS")}</Checkbox>
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        name={["format"]}
                        label={t("DOWNLOAD.FORMAT")}
                        rules={[{ required: true, message: t("FROM.ERROR.PLEASE_SELECT_VALUE") }]}
                    >
                        <Select disabled={submitting} placeholder={t("DOWNLOAD.FORMAT")}>
                            {[ExportFormat.XLSX, ExportFormat.XLS, ExportFormat.CSV].map((item) => (
                                <Select.Option key={item} value={item}>
                                    {item.toUpperCase()}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
        </ExportBlob>
    )
}